<template>
  <b-modal v-model="isModalVisible" id="changePasswordModal" size="md" hide-footer>
    <template slot="modal-header">
      <b-col>
        <span class="h6 mt-0 mb-0">{{ $t('modals.profile.editProfileHeader') }}</span>
        <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('changePasswordModal')">
          ×
        </button>
      </b-col>
    </template>
    <b-row>
      <b-col>
        <change-password-form
          @submit="submit()"
          :values="item"
          :errors="violations"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ChangePasswordForm from './ChangePasswordForm'
import { getUserRoles } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  name: 'changePasswordModal',
  components: {
    ChangePasswordForm
  },
  data () {
    return {
      item: {
        newPassword: '',
        newPasswordConfirmation: '',
        oldPassword: ''
      },
      isModalVisible: false,
      violations: {}
    }
  },
  computed: {
    validation () {
      return false
    }
  },
  watch: {
    'isModalVisible' () {
      this.reset()
    }
  },
  methods: {
    async submit () {
      let link = `users/${getUserRoles().id}/update_password`
      const response = await new ApiService(link).putSilent(this.item)
      if (response.status === 200) {
        const text = await response.json()
        await this.$Swal({
          type: 'success',
          title: text
        })
        this.isModalVisible = false
      } else {
        this.violations = response
      }
    },
    reset () {
      this.item = {
        newPassword: '',
        newPasswordConfirmation: '',
        oldPassword: ''
      }
      this.violations = {}
    },
    onSendForm () {
      this.update()
    },
    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>

<style scoped>

</style>
